import useSegments from '../useSegments';
/**
 * Obtains the segments the current user is authorized to operate with
 */
const useUserSegments = (showSubSegments = false) => {
  const props = useSegments(true, showSubSegments); //TODO: replace with logic that uses the current logged user data

  return props;
};

export default useUserSegments;
